import { Offcanvas, Form, Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import ReactQuill from "react-quill-new";
import { quillImageHandler } from "../../utility/quilImageHandler";
import CommonQuill from "../../components/editor/CommonQuill";
import HelperService from "../../utility/HelperService";

interface EventFormData {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  title: string;
  description: string;
  resource_type: string;
  tagId: string;
  category: string;
  publishedAt: string;
  keywords?: string;
  meta_description?: string;
  slug?: string;
  createdBy?: string;

};
interface Tag {
  _id: string;
  name: string;
}

const AddRegulation = ({ show, handleClose, data }: EventFormData) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
    trigger,
  } = useForm<FormData>();

  const [isLoading, setLoading] = useState(false);
  // const [banner, setBanner] = useState<File | string | null>(null);
  const [pdfFile, setPdfFile] = useState<File | string | null>(null);
  const [value, setEditorValue] = useState("");
  const [tagsList, setTagsList] = useState<any[]>([]);
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const quillRef = useRef<any>(null);
  const [customErrors, setCustomErrors] = useState<{
    description?: string;
  }>({});
  const titleValue = watch("title");
  useEffect(() => {

    //Edit mode me slug ko kabhi change nahi karna
    if (data?._id) return;

    if (!titleValue) {
      setValue("slug", "");
      return;
    }

    // ✅ Only auto-generate when adding
    if (!data?._id) {
      const slug = HelperService.generateSlug(titleValue);
      setValue("slug", slug);
    }
  }, [titleValue, data]);
  useEffect(() => {
    if (show) {
      const storedUser = localStorage.getItem("UserData");
      const userData = data?.user || (storedUser ? JSON.parse(storedUser) : null);
      const formattedDate = data?.publishedAt
        ? new Date(data.publishedAt).toISOString().split("T")[0]
        : "";
      reset({
        title: data?.title || "",
        description: data?.description || "",
        resource_type: "REGULATION",
        tagId: data?.tagId?._id || data?.tagId || "",
        publishedAt: formattedDate,
        keywords: data?.keywords || "",
        meta_description: data?.meta_description || "",
        slug: data?.slug || "",
        category: data?.category?._id || data?.category || "",
        createdBy: data?.createdBy?.fullName || "",
      });
      setEditorValue(data?.description || "");
      fetchTags();
      fetchCategories();
      // ✅ preload existing banner & file
      // if (data?.banner) {
      //   setBanner(data.banner);
      // }
      if (data?.file) {
        setPdfFile(data.file);
      }
    } else {
      reset({});
      // setBanner(null);
      setPdfFile(null);
    }
  }, [show, data, reset]);
  const fetchTags = async () => {
    try {
      const res: any = await WebService.getAPI({
        action: `tags/get-tags/REGULATION`, // no pagination params
        body: null,
      });

      const tags: Tag[] = res?.data || [];

      setTagsList(tags);

      // ✅ If editing existing data, auto-select the tag
      // if (data?.tagId) {
      //   const tagExists = tags.some((tag: Tag) => tag._id === data.tagId);
      //   if (tagExists) setValue("tagId", data.tagId);
      // }
    } catch (err) {
      console.error("Error fetching tags:", err);
    }
  };

  const fetchCategories = async () => {
    try {
      const res: any = await WebService.getAPI({
        action: `categories/get-list/REGULATION`,
        body: null,
      });

      setCategoryList(res?.data || []);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const isQuillEmpty = (value?: string) => {
    if (!value) return true;

    // remove html tags, &nbsp; and spaces
    const text = value
      .replace(/<(.|\n)*?>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  };
  const validateInfoTab = async () => {
    const titleValid = await trigger(["title"]);

    const newErrors: any = {};

    if (isQuillEmpty(value)) {
      newErrors.description = "Description is required";
    }

    setCustomErrors(newErrors);

    // 🔥 IMPORTANT: return actual validity
    return titleValid && !newErrors.description;
  };
  const onSubmit = async (request: FormData) => {
    const valid = await validateInfoTab();
    if (!valid) {
      toast.error("Please fill required fields");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    const storedUser = localStorage.getItem("UserData");
    const userData = data?.user || (storedUser ? JSON.parse(storedUser) : null);
    formData.append("title", request.title);

    const editor = quillRef.current?.getEditor();
    const html = editor?.root.innerHTML || "";
    formData.append("description", html || "");
    formData.append("resource_type", "REGULATION");
    formData.append("tagId", request.tagId || "");
    formData.append("category", request.category || "");
    formData.append("keywords", request.keywords || "");
    formData.append("meta_description", request.meta_description || "");
    formData.append("slug", request.slug || "");
    if (request.publishedAt)
      formData.append("publishedAt", request.publishedAt);
    // if (banner && banner instanceof File) {
    //   formData.append("banner", banner); // only send new banner file
    // }
    if (pdfFile && pdfFile instanceof File) {
      formData.append("file", pdfFile); // only send new pdf file
    }
    if (userData?._id) {
      formData.append("createdBy", userData._id);
    }
    const apiCall = data?._id
      ? WebService.fileUploadPutAPI({
        action: `resources/edit-resource/${data._id}`,
        body: formData,
      })
      : WebService.fileUploadAPI({
        action: `resources/add-resource`,
        body: formData,
      });

    apiCall
      .then((res: any) => {
        toast.success(res.message);
        reset();
        handleClose();
        // setBanner(null);
        setPdfFile(null);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message || "An error occurred");
      });
  };

  return (
    <Offcanvas
      show={show}
      onHide={() => {
        reset();
        // setBanner(null);
        setPdfFile(null);
        handleClose();
      }}
      placement="end"
      className="offcanvas-custom"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {data ? "Edit Representation" : "Add Representation"}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Card className="p-3 bg-light my-3 position-relative">
            <span
              className="bg-white position-absolute rounded small"
              style={{ top: "-12px", left: "12px", padding: "0 8px" }}
            >
              Main Content
            </span>
            {/* Title */}
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                {...register("title", { required: "Title is required" })}
              />
              {errors.title && (
                <div className="error-message">{errors.title.message}</div>
              )}
            </Form.Group>
            <Form.Group className="mb-2" controlId="slugField">
              <Form.Label className="label">Slug</Form.Label>{" "}
              <span className="text-danger">*</span>
              <Form.Control
                type="text"
                placeholder="Auto-generated slug"
                {...register("slug", { required: "Slug is required" })}
                value={watch("slug") || ""}
              />
            </Form.Group>
            {/* Description */}
            <Form.Group className="mb-2" controlId="eventDescription">
              <Form.Label className="label">
                Description <span className="text-danger">*</span>
              </Form.Label>

              <CommonQuill
                ref={quillRef}
                value={value}
                onChange={setEditorValue}
                storage="resources"
                initialHtml={show && data?.description ? HelperService.normalizeResizeHtml(data.description) : undefined}
                onClearError={() =>
                  setCustomErrors((p) => ({
                    ...p,
                    description: undefined,
                  }))
                }
              />
              {customErrors.description && (
                <div className="error-message">{customErrors.description}</div>
              )}
            </Form.Group>
            {/* Removed banner upload as per requirement 6 Nov 2025*/}
            {/* Banner Upload */}
            {/* <Form.Group className="mb-2" controlId="bannerFile">
            <Form.Label className="label">Upload Banner</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              className="custom-file-upload"
              onChange={(e) => {
                const input = e.target as HTMLInputElement;
                const selectedFile = input.files && input.files[0];
                if (selectedFile) {
                  setBanner(selectedFile);
                }
              }}
            />
          </Form.Group>

          {banner && (
            <div className="mb-2 event-file">
              <img
                src={
                  banner instanceof File ? URL.createObjectURL(banner) : banner
                }
                alt="Banner Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: 200,
                  objectFit: "contain",
                }}
              />
            </div>
          )} */}

            {/* Tags Dropdown */}
            <Form.Group className="mb-2" controlId="eventTag">
              <Form.Label className="label">
                Tag <span className="text-danger">*</span>
              </Form.Label>

              <Form.Select
                {...register("tagId", { required: "Please select a tag" })}
                size="sm"
                value={watch("tagId") || ""}
              >
                <option value="">Select Tag</option>
                {tagsList.map((tag: { _id: string; name: string }) => (
                  <option key={tag._id} value={tag._id}>
                    {tag.name}
                  </option>
                ))}
              </Form.Select>

              {errors.tagId && (
                <div className="error-message">{errors.tagId.message}</div>
              )}
            </Form.Group>

            <Form.Group className="mb-2" controlId="eventCategory">
              <Form.Label className="label">
                Category
              </Form.Label>

              <Form.Select
                {...register("category")}
                size="sm"
                value={watch("category") || ""}
              >
                <option value="">Select Category</option>
                {categoryList.map((cat: any) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </Form.Select>

              {/* {errors.category && (
                <div className="error-message">{errors.category.message}</div>
              )} */}
            </Form.Group>

            {/* <Form.Group className="mb-2" controlId="isFeatured">
            <Form.Check
              type="checkbox"
              label="Featured"
              {...register("featured")}
            />
          </Form.Group> */}
            <Form.Group className="mb-2" controlId="eventDate">
              <Form.Label className="label">
                Published Date <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                max={new Date().toISOString().split("T")[0]}
                {...register("publishedAt", { required: "Date is required" })}
              />
              {errors.publishedAt && (
                <div className="error-message">
                  {errors.publishedAt.message}
                </div>
              )}
            </Form.Group>
            <Form.Group className="mb-2" controlId="createdBy">
              <Form.Label className="label">Created By</Form.Label>
              <Form.Control
                type="text"
                placeholder="Created by user"
                {...register("createdBy")}
                value={watch("createdBy") || ""}
                disabled
              />
            </Form.Group>
          </Card>
          <Card className="p-3 bg-light my-3 position-relative">
            <span
              className="bg-white position-absolute rounded small"
              style={{ top: "-12px", left: "12px", padding: "0 8px" }}
            >
              Media
            </span>
            {/* PDF Upload */}
            <Form.Group className="mb-2" controlId="pdfFile">
              <Form.Label className="label">Upload PDF File <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="file"
                accept=".pdf"
                className="custom-file-upload"
                onChange={(e) => {
                  const input = e.target as HTMLInputElement;
                  const selectedFile = input.files && input.files[0];
                  if (selectedFile) {
                    setPdfFile(selectedFile);
                  }
                }}
              />
              <span className="text-primary" style={{ fontSize: "12px" }}>
                Note: Only PDF files are allowed. Maximum upload size is 100 MB
                MB{" "}
              </span>
            </Form.Group>

            {/* PDF Preview */}
            {pdfFile && (
              <div className="mb-2 event-file">
                <a
                  href={
                    pdfFile instanceof File
                      ? URL.createObjectURL(pdfFile)
                      : (pdfFile as string)
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </div>
            )}
          </Card>
          <Card className="p-3 bg-light my-3 position-relative">
            <span
              className="bg-white position-absolute rounded small"
              style={{ top: "-12px", left: "12px", padding: "0 8px" }}
            >
              SEO
            </span>
            <Form.Label className="label">Meta Description <span className="text-danger">*</span></Form.Label>
            <Form.Control
              as="textarea"
              placeholder="Meta Description"
              {...register("meta_description", {
                required: "Meta description is required",
              })}
            />
            {errors.meta_description && (
              <div className="error-message">
                {errors.meta_description.message}
              </div>
            )}
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                Keywords <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter keywords"
                {...register("keywords", { required: "Keywords are required" })}
              />
              {errors.keywords && (
                <div className="error-message">{errors.keywords.message}</div>
              )}
            </Form.Group>
          </Card>
        </Form>
      </Offcanvas.Body>
      <div className="d-flex justify-content-end p-3">
        <CustomButton
          isLoading={isLoading}
          label="Save"
          className="w-100"
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </Offcanvas>
  );
};

export default AddRegulation;
